import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfEmployeeStatus(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "EMPLOYEE STATUS", key: "employee_status", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.employee_status_code ?? "-",
    employee_status: item.employee_status_name ?? "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="Employee Status" />
  );
}
